(function ($) {
    var _this = {
        'dom': {
            'posts': $('#post-container'),
            'pagination': $('#pagination-container'),
        },
        'pages': {
            'max': '',
            'current': 1
        },
        'baseURL': '',
        setup: function () {
            _this.pages.max = _this.dom.pagination.data('max');
            _this.pages.current = _this.dom.pagination.data('current');
            _this.baseURL = _this.dom.pagination.data('base-url');

            _this.setupButton();
            _this.setupPagination();
            _this.checkPage();
            _this.watchPagination();
        },
        setupPagination: function () {
            _this.dom.pagination.find('.tool-pagination').addClass('hidden');
        },
        setupButton: function(){
            var text = _this.dom.pagination.data('load-more-text');
            var button = $('<a class="j-pagination--loadmore s-button__dark" tabindex="0">'+ text +'</a>').attr('data-max', _this.pages.max).attr('data-current', _this.pages.current);
            button.appendTo(_this.dom.pagination);
        },
        checkPage: function(){
            if(_this.pages.current < _this.pages.max && _this.pages.max > 1){
                _this.showPagination();
            }else{
                _this.hidePagination();
            }
        },
        showPagination: function () {
            _this.dom.pagination.removeClass('hidden');
        },
        hidePagination: function () {
            _this.dom.pagination.addClass('hidden');
        },
        watchPagination: function (){
            _this.dom.pagination.on('click','.j-pagination--loadmore',function(){
                _this.getMorePosts();
            });
        },
        getMorePosts: function(){
            _this.pages.current++;
            _this.dom.pagination.addClass('loading-more');
            var pagination_url = _this.baseURL + '/page/' + _this.pages.current;
            jQuery.ajax({
                dataType: 'text',
                url: pagination_url,
                success: function (rawhtml) {
                    var results = $(rawhtml);
                    var posts = results.find('#post-container').html();
                    _this.dom.posts.append(posts);
                    _this.checkPage();
                    _this.dom.pagination.removeClass('loading-more');

                }
            });
        }
    };
    // Attach Toolbox to window
    window.pagination = _this;
})(jQuery); // Fully reference jQuery after this point.
